module.exports = __webpack_public_path__ + "static/jobboard-b881217722f526cb1476317bd3795cc1.png";